export default {
  placeholder: 'Vyberte položku…',
  loadingMessage: 'Načítání…',
  noOptionsMessage: 'Žádné položky',
};
